module.exports = __webpack_public_path__ + "static/img/server20.fa37470.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/server20.png
// module id = rvrr
// module chunks = 0